const nodeHeight = 20;
const yMarg = 10;
const xMarg = 10;

// editorService.js

export const Actions = {
	MOUSE_DOWN_ON_NODE: "mouseDownNode",
	MOUSE_DOWN_ON_EMPTY: "mouseDownEmpty",
	MOUSE_UP: "mouseUp",
	MOUSE_MOVE: "mouseMove"
}

export const MouseState = {
	UP: "up",
	DOWN_ON_NODE: "downNode",
	DOWN_ON_EMPTY: "downEmpty",
	DRAGGING_NODE: "draggingNode",
	DRAGGING_EMPTY: "draggingEmpty",
	DOWN_ON_MIRROR: "downMirror"
}

export const handleTransition = (ctx, state, newState) => {
	let updatedState = { 
        ...newState, 
        model: { ...newState.model } 
    };

	if (state.mouseState === MouseState.UP && updatedState.mouseState === MouseState.DOWN_ON_NODE) {
		console.log("handleTransition","down on node", JSON.stringify(updatedState))
		let locationNode = findLocationNode(updatedState.selectionContext.clickedId, updatedState.model)
		updatedState.mouseContext = {
			...newState.mouseContext,
			xOffset: locationNode.x - newState.mouseContext.x,
			yOffset: locationNode.y - newState.mouseContext.y
		}
	}
	//Create Node
	else if (state.mouseState === MouseState.DOWN_ON_EMPTY && updatedState.mouseState === MouseState.UP) {
		console.log("handleTransition","up on empty", JSON.stringify(updatedState))
		let node = addNode(updatedState)
		updatedState.selectionContext.selectedNodeId = node.id
		updatedState.selectionContext.selectedNode = node
		updatedState.selectionContext.selectedLocationNode = findLocationNode(node.id, updatedState.model)
		handleSelectionAndConnection(updatedState)
	}
	else if (state.mouseState === MouseState.DOWN_ON_NODE && updatedState.mouseState === MouseState.UP) {
		console.log("handleTransition","up on node", JSON.stringify(updatedState))
		let node = findNode(updatedState.selectionContext.selectedNodeId, updatedState.model)
		updatedState.selectionContext.selectedNodeId = node.id
		updatedState.selectionContext.selectedNode = node
		updatedState.selectionContext.selectedLocationNode = findLocationNode(node.id, updatedState.model)
		handleSelectionAndConnection(updatedState)
	}
	//Move Node
	else if (updatedState.mouseState === MouseState.DRAGGING_NODE) {
		console.log("handleTransition","dragging node", JSON.stringify(updatedState))
		moveNode(updatedState)
	}

	if(state.mouseState !== newState.mouseState){
		console.log("handleTransition","end", JSON.stringify(updatedState))
	}

	return updatedState
}

const handleSelectionAndConnection = (state) => {
	let previousId = state.selectionContext.previousNodeId
	let id = state.selectionContext.selectedNodeId
	let model = state.model
	console.log("handleSelectionAndConnection", previousId, id, JSON.stringify(state))

	if (previousId != null) {
		let connection = findConnection(previousId, id, model)
		//Select existing connection
		if (connection != null) {
			state.selectionContext = { selectedConnection: connection }
		}
		//Connect
		else {
			connect(previousId, id, model)
			//Node is selected from updateState
		}
	}
}

const addNode = (state) => {

	let newNode = getNode("", "field")
	state.model.nodes = [...state.model.nodes, newNode]

	let locationNode = { id: newNode.id, x: state.mouseContext.x, y: state.mouseContext.y }
	state.model.locationNodes = [...state.model.locationNodes, locationNode]

	return newNode
}

const connect = (previousId, newId, model) => {
	console.log("Connect: " + previousId + " -> " + newId)

	let selectedConnection = { from: previousId, to: newId, name: "" }
	model.connections = [...model.connections, selectedConnection]

	return selectedConnection
}

const findConnection = (id1, id2, model) => {
	return model.connections.find(c => c.from === id1 && c.to === id2)
}

const findLocationNode = (id, model) => {
	return model.locationNodes.find(n => n.id === id)
}

const findNode = (id, model) => {
	return model.nodes.find(n => n.id === id)
}

export const getConnectionCoordinates = (connection, model) => {
	let fromLocation = model.locationNodes.find(n => n.id === connection.from)
	let toLocation = model.locationNodes.find(n => n.id === connection.to)

	// Line start and end points
	const x1 = fromLocation.x, y1 = fromLocation.y;
	const x2 = toLocation.x, y2 = toLocation.y;

	return [(x1 + x2) / 2, (y1 + y2) / 2]
}

const moveNode = (state) => {
	let node = state.selectionContext.selectedLocationNode
	if (node != null) {
		node.x = state.mouseContext.x + state.mouseContext.xOffset
		node.y = state.mouseContext.y + state.mouseContext.yOffset
	}
}

const getNode = (name, type) => {
	let id = getUniqueId()
	console.log("getNode", id)
	return {
		id: id,
		name: name,
		type: type
	}
}

function getUniqueId() {
	return Math.random().toString(36).substring(2, 5) + Date.now().toString(36);
}

export const updateStateWithMouseDownOnNode = (state, nodeId, x, y) => {
	let newState = { ...state }

	newState.mouseState = MouseState.DOWN_ON_NODE
	newState.mouseContext = { x: x, y: y }
	newState.selectionContext = { ...state.selectionContext, clickedId: nodeId }

	return newState
}

export const updateStateWithMouseDownOnEmpty = (state, x, y) => {
	let newState = { ...state }

	newState.mouseState = MouseState.DOWN_ON_EMPTY
	newState.mouseContext = { x: x, y: y }
	newState.selectionContext = { ...state.selectionContext, clickedId: null }

	return newState
}

export const updateStateWithMouseUp = (state, x, y) => {
	let newState = { ...state }

	if (state.mouseState === MouseState.DOWN_ON_NODE) {
		newState.mouseState = MouseState.UP
		newState.selectionContext = { previousNodeId: state.selectionContext.selectedNodeId, selectedNodeId: state.selectionContext.clickedId }
	} else if (state.mouseState === MouseState.DOWN_ON_EMPTY) {
		newState.mouseState = MouseState.UP
		newState.selectionContext = { previousNodeId: state.selectionContext.selectedNodeId, selectedNodeId: null }
	} else if (state.mouseState === MouseState.DRAGGING_NODE) {
		newState.mouseState = MouseState.UP
	} else if (state.mouseState === MouseState.DRAGGING_EMPTY) {
		newState.mouseState = MouseState.UP
	} else {
		//Unexpected, reset state
		newState.mouseState = MouseState.UP
	}

	return newState
}

export const updateStateWithMouseMove = (state, x, y) => {
	let newState = { ...state }

	newState.mouseContext = { ...state.mouseContext, x: x, y: y }

	if (state.mouseState === MouseState.DOWN_ON_NODE) {
		newState.mouseState = MouseState.DRAGGING_NODE
		newState.selectionContext = {
			...state.selectionContext,
			selectedConnection: null,
			selectedNodeId: state.selectionContext.clickedId,
			selectedLocationNode: findLocationNode(state.selectionContext.clickedId, state.model)
		}
	} else if (state.mouseState === MouseState.DOWN_ON_EMPTY) {
		newState.mouseState = MouseState.DRAGGING_EMPTY
	}

	return newState
}

export const getClickCoordinates = (rect, event) => {
	let newX, newY
	if(['touchstart', 'touchmove'].includes(event.type) ){
		newX = event.touches[0].clientX
		newY = event.touches[0].clientY
	}else{
		newX = event.clientX
		newY = event.clientY
	}

	newX = Math.round(newX - rect.left);         // X coordinate within canvas
	newY = Math.round(newY - rect.top);          // Y coordinate within canvas
	return [newX, newY]
}

export const findClickedNode = (ctx, model, newX, newY) => {

	for (let locationNode of model.locationNodes) {
		// console.log(`MouseDown: (${locationNode.x},${locationNode.y})`)
		let node = model.nodes.find(n => n.id === locationNode.id)
		let text = node?.name
		let width = ctx.measureText(text).width;
		let leftX = locationNode.x - (0.5 * (width + xMarg))
		let rightX = locationNode.x + (0.5 * (width + xMarg))
		let topY = locationNode.y - (0.5 * (nodeHeight))
		let bottomY = locationNode.y + (0.5 * (nodeHeight))


		let margin = 20
		if (newX >= leftX - margin && newX <= rightX + margin && newY >= topY - margin && newY <= bottomY + margin) {
			return [locationNode, node, text]
		}
	}
	return null
}
